import React, { useState, useCallback } from 'react'
import { TextField, IconButton, Typography, Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { formObjAdd, formArrayAdd, formObjDelete, formArrayDelete, formChange } from '../../../../reducers/form';
import DeleteIcon from '@mui/icons-material/Delete';

export default function SetWorkTab({ formName }) {
  const [value, setValue] = useState('')
  const [idRow, changeRow] = useState(0)
  const [keyOver, chngeKeyOver] = useState('')
  const dispatch = useDispatch()
  const form = useSelector(state => state.form[formName] || state.form.default)
  const changeArr = useCallback((arr) => dispatch(formChange(arr, { field: 'wkAllIds', name: formName })), [dispatch, formName])
  const addRow = (active) => {
    if (!active) return;
    dispatch(formObjAdd({ name: value }, {
      field: 'wkById',
      id: 'id' + (idRow + 1),
      name: formName,
    }))
    dispatch(formArrayAdd('id' + (idRow + 1), {
      field: 'wkAllIds', name: formName, end: true
    }))
    setValue('')
    changeRow(idRow + 1)
  }
  const { wkAllIds = [], wkById = {} } = form.values
  const deleteRow = (id) => {
    dispatch(formArrayDelete(id, { field: 'wkAllIds', name: formName }));
    dispatch(formObjDelete({ id: id, field: 'wkById', name: formName }));
  }
  const handleDragStart = (key) => {
    console.log('start drag', key)
  }
  const handleDragEnd = (key) => {
    if (key === keyOver) return;
    if (keyOver === '') return;
    const overId = wkAllIds.indexOf(keyOver)
    const arrDel = wkAllIds.filter(v => v !== key)
    const arr = [...arrDel.slice(0, overId), key, ...arrDel.slice(overId)]
    changeArr(arr)
    chngeKeyOver('')
  }
  const handleDragOver = (key) => {
    chngeKeyOver(key)
  }
  return <div>
    <TextField
      value={value}
      variant="standard"
      onChange={(e) => setValue(e.target.value)}
      onKeyDown={(e) => addRow(e.keyCode === 13)}
      fullWidth
    />
    <div>
      {wkAllIds.map((key, index) => {
        const obj = wkById[key]
        return <Row key={key} id={key} index={index + 1} obj={obj} action={{ deleteRow, handleDragStart, handleDragEnd, handleDragOver }} />
      })}
    </div>
    <p />
  </div>
}

function Row({ id, obj, action, index }) {
  return <div key={id} draggable
    // onDragStart={() => action.handleDragStart(id)}
    onDragEnd={() => action.handleDragEnd(id)}
    onDragOver={() => action.handleDragOver(id)}
  >
    <Grid
      container
      direction='row'
      justifyContent="flex-start"
      alignItems="center"
    >
      <Grid item  ><IconButton aria-label="Delete" onClick={() => action.deleteRow(id)} size='small' ><DeleteIcon /></IconButton></Grid>
      <Grid style={{paddingLeft:'1rem'}}><Typography>{index+'.'}</Typography></Grid>
      <Grid item style={{paddingLeft:'1rem'}}><Typography>{obj.name}</Typography></Grid>
    </Grid>
  </div>
}